import {getStack} from '@ns/ns-contentstack-lib';
import {RunConfigService} from '@nuskin/ns-util';

/**
 * Get translations for checkout
 * @return {Promise<object>} strings - translations for checkout
 */
export async function getStrings() {
    const Stack = getStack();
    const runConfig = RunConfigService.getRunConfig();
    const lang = runConfig.language === 'in' ? 'id' : runConfig.language;
    const strings = await Stack.getStrings({
        contentTypes: [
            'checkout_adr_strings'
        ],
        country: runConfig.country,
        language: lang,
        merge: true
    });

    return strings;
}
